module.exports = __webpack_public_path__ + "img/mortgage-questions.bc2cb41.png";